module.exports = __webpack_public_path__ + "static/media/icon-trash-white.df646bf4.svg";